export default __webpack_public_path__ + "static/media/12.22f5299c.jpg";